import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import useMyMApi from "../../hooks/useMyMApi";
import { MyMProgress } from '../../ui-elements/MyMProgress';
import { SurveyListResult } from '../MYM803_SurveyManagement/SurveyListResult';

/**MyMine Version2.0 SurveyManagement画面新規追加
 * SurveyManagement Page Component
 */
const SurveyManagement = () => {
  const screenId = 'MyM803'; // スクリーンID
  const apiRequest = useMyMApi(screenId);
  const [surveyList, setSurveyList] = useState([]);
  // ページ再表示要否
  const [needsRefreshPage, setNeedsRefreshPage] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const callbackSuccess = (result) => {
      setSurveyList(result);
      setIsLoading(false);
    }
    const callbackFail = () => {
      setIsLoading(false);
    };
    // APIリクエストを送信
    apiRequest.requestJson('api/survey/survey-list', 'GET', callbackSuccess, callbackFail);
  }, []);
  useEffect(() => {
    setIsLoading(true);
    if (isLoading) return;
    updateSurveyList();
    setNeedsRefreshPage(false);
  }, [needsRefreshPage]);

  //再表示処理
  const updateSurveyList = () => {
    
    const callbackSuccess = (result) => {
      setSurveyList(result);
      setIsLoading(false);
    };
    const callbackFail = () => {
      setIsLoading(false);
    };
    // APIリクエストを送信
    apiRequest.requestJson('api/survey/survey-list', 'GET', callbackSuccess, callbackFail);
  };

  if (isLoading)
    <MyMProgress />;

  return (
    <>
      <Box>
        <SurveyListResult
          screenId={screenId}
          surveyList={surveyList}
          needsRefreshPage={needsRefreshPage}
          setNeedsRefreshPage={setNeedsRefreshPage}
          isLoading={isLoading}
        />
        </Box>
    </>
  );
}
export default SurveyManagement;